const API_BASE_URL = 'https://aol-mulund-api.hokage-mihir.workers.dev';

class MultiWebsiteApiClient {
  constructor(websiteKey) {
    this.baseUrl = API_BASE_URL;
    this.websiteKey = websiteKey;
    this.token = localStorage.getItem('auth_token');
    this.user = JSON.parse(localStorage.getItem('auth_user') || 'null');
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Key': this.websiteKey,
        ...options.headers,
      },
      ...options,
    };

    if (this.token) {
      config.headers.Authorization = `Bearer ${this.token}`;
    }

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  setAuth(token, user) {
    this.token = token;
    this.user = user;
    if (token && user) {
      localStorage.setItem('auth_token', token);
      localStorage.setItem('auth_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
    }
  }

  // Authentication
  async login(username, password) {
    const response = await this.request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
    
    if (response.success) {
      this.setAuth(response.token, response.user);
    }
    
    return response;
  }

  async verifyToken() {
    return this.request('/api/auth/verify', {
      method: 'POST'
    });
  }

  logout() {
    this.setAuth(null, null);
  }

  isLoggedIn() {
    return !!this.token && !!this.user;
  }

  isAdmin() {
    return this.user?.role === 'admin';
  }

  // Program management
  async getPrograms() {
    return this.request('/api/programs');
  }

  async createProgram(programData) {
    return this.request('/api/admin/programs', {
      method: 'POST',
      body: JSON.stringify(programData),
    });
  }

  async updateProgram(id, programData) {
    return this.request(`/api/admin/programs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(programData),
    });
  }

  async deleteProgram(id) {
    return this.request(`/api/admin/programs/${id}`, {
      method: 'DELETE',
    });
  }

  // Event management
  async getEvents() {
    return this.request('/api/events');
  }

  async createEvent(eventData) {
    return this.request('/api/admin/events', {
      method: 'POST',
      body: JSON.stringify(eventData),
    });
  }

  async updateEvent(id, eventData) {
    return this.request(`/api/admin/events/${id}`, {
      method: 'PUT',
      body: JSON.stringify(eventData),
    });
  }

  async deleteEvent(id) {
    return this.request(`/api/admin/events/${id}`, {
      method: 'DELETE',
    });
  }
}

export const createApiClient = (websiteKey) => new MultiWebsiteApiClient(websiteKey);
export default MultiWebsiteApiClient;